import SearchContext from 'contexts/SearchContext';
import React, { useContext } from 'react';
import { setCategory, setFilters, setPage } from 'contexts/SearchActions';
import Category from 'models/Category';
import CategoryIcon from 'components/icons/CategoryIcon';
import HorizontalScroller from 'components/search/HorizontalScroller';
import { Check, X } from 'react-feather';
import FeaturedPoiTypeBadge from 'components/search/Filters/FeaturedPoiTypeBadge';

function SearchCategories() {
    const { state, dispatch } = useContext(SearchContext);
    const availableCategories = state.categories;

    const categoryClicked = (category: Category) => {
        if (state.category?.slug === category.slug) {
            return setCategory(dispatch, null);
        }
        setPage(dispatch, 1);
        setFilters(dispatch, []);
        setCategory(dispatch, category);
    };

    return (
        <HorizontalScroller>
            <div className="flex gap-2 pl-4 pt-6 pb-3">
                {availableCategories.map((cat) => {
                    const isSelected = state.category?.slug === cat.slug;
                    return (
                        <button
                            key={cat.id}
                            className={`group rounded-full border border-gray-300 flex items-center 
                            gap-1 py-1 px-2 text-sm outline-none focus:outline-none transition 
                            relative first:ml-auto 
                            ${isSelected ? 'bg-brand-light border-brand' : 'hover:bg-brand-dull'}`}
                            onClick={() => categoryClicked(cat)}
                        >
                            {cat.slug === 'nagradni-izbor' && <FeaturedPoiTypeBadge />}

                            {isSelected ? (
                                <>
                                    <span className="group-hover:hidden">
                                        <Check width={18} height={17} />
                                    </span>
                                    <span className="hidden group-hover:block">
                                        <X width={18} height={17} />
                                    </span>
                                </>
                            ) : (
                                <CategoryIcon slug={cat.slug} size={18} />
                            )}

                            <span>{cat.name}</span>
                        </button>
                    );
                })}
                <div className="pr-6 mr-auto"></div>
            </div>
        </HorizontalScroller>
    );
}

export default SearchCategories;
